import * as React from "react";
import { LineChart } from '@mui/x-charts';

const SimpleLineChart = ({ chart_data, isFullWidth, layout, isArea }) => {

    const { chartType, type, chart_type, xAxis, yAxis, daily, weekly, data } = chart_data;
    const chartViewType = chartType || type || chart_type;
    const isMultipleTabs = daily && weekly;

    const getChartData = () => {
        const xData = data?.map((d) => d?.xAxis);
        const yData = data?.map((d) => d?.yAxis);
        return { xData, yData };
    };

    const { xData, yData } = getChartData();

    return (
        <div style={isFullWidth ? styles.cardFull : styles.cardHalf}>
                <h3>{chart_data?.title || chart_data?.chart_name}</h3>
                <p>{chart_data?.description}</p>
                <LineChart
                    xAxis={[{ id: xAxis, data: xData, scaleType: 'band',label:chart_data?.xAxis }]}
                    series={[{ data: yData,area: isArea,label:chart_data?.yAxis }]}
                    height={360}
                    grid={{ vertical: true, horizontal: true }}
                />
            </div>
    );

}

const styles ={
    cardHalf: {
        flex: 0.48,
        padding: 20,
        border: '1px solid #ccc',
        borderRadius: '12px',
        boxShadow: '0px 2px 8px rgba(0,0,0,0.1)',
        textAlign: 'left',
      },
      cardFull: {
        flex: 1,
        padding: 20,
        border: '1px solid #ccc',
        borderRadius: '12px',
        boxShadow: '0px 2px 8px rgba(0,0,0,0.1)',
        textAlign: 'left',
      },
};

export default SimpleLineChart;